const Menu =  [
    { header: 'Sys Admin' },
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'fa-dashboard', 
        meta    : {breadcrumb:false}
    },                   
    {
        title : 'Menghitung',
        group : 'hitung',
        icon  : 'touch_app',        
        items : [
          {title:'By Form', meta:{breadcrumbs:false}},
          {title:'By Excel', name:'byexcel'}
        ]
    },
    //{ title : 'KPU Match', name: 'matching/explore', icon:'settings_input_component', meta:{breadcrumbs:false}},
    { title : 'Kesalahan', name: 'analisis', icon:'whatshot', meta:{breadcrumbs:false}},
    { title : 'Report', name: 'report', icon:'assignment'},
    {
        title: 'Saksi/Child',
        name : 'saksi',
        icon : 'contacts',
        meta : {breadcrumb:false}
    },     
    {
        title: 'Master',          
        icon:'brightness_4',       
        items: [
            { title : 'Kompetisi', name: 'kompetisi', icon:'event'},
            { title : 'Partai', name: 'partai', meta:{breadcrumbs:false}},
            { title : 'Calon', name: 'calon', icon:'face', meta:{breadcrumbs:false}},            
        ]
    },  
    {
        title: 'Area/Dapil/TPS',         
        group: 'adm',
        icon : 'public',        
        items: [
            { title : 'Provinsi', name: 'provinsi'},
            { title : 'Kota/Kab', name : 'kota' },
            { title : 'Kecamatan', name: 'kecamatan' },            
            { title : 'Kelurahan', name: 'kelurahan' },
            { title : 'Dapil', name: 'dapil' },  
            { title : 'Tps', name: 'tps' },
                      
        ]
    },  
    {
        title: 'All Users',
        name : 'user',
        icon : 'person',
        meta : {breadcrumb:false}
    },
    {
        title   : 'RBAC Auth',
        group   : 'rbac',
        icon    : 'pets',                    
        items: [
            {title: 'Routes', name: 'routes'},
            {title: 'Permissions', name: 'permissions'},
            {title: 'Roles', name: 'roles'},
            {title: 'Assignment', name: 'assignment'}            
        ]
    },
    
    
    //NON MENU
    { title : 'Provinsi', name: 'pages/home',visible: false},
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Explore', name: 'explore', meta:{breadcrumbs:false} },
        { title : 'Live', name: 'live', meta:{breadcrumbs:false, public:true} },
      ]
    },
    { group: 'hitung',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },
    { group: 'analisis',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },
    { group: 'report',
      visible: false,
      items:[
        { title : 'C1', name: 'c1' },
        { title : 'D1', name: 'd1' },
        { title : 'DA1', name: 'da1' },
        { title : 'DB1', name: 'db1' },
        { title : 'DC1', name: 'dc1' },
      ]
    },
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
    {
        group: 'adm',
        visible : false,
        items: [
            { title : 'Provinsi', name: 'provinsi/form'},
            { title : 'Kota/Kab', name: 'kota/form' },
            { title : 'Kecamatan', name: 'kecamatan/form' },            
            { title : 'Kelurahan', name: 'kelurahan/form' },
            { title : 'Dapil', name: 'dapil/form' },
            { title : 'Tps', name: 'tps/form' },
        ]
    },
    { group: 'kompetisi',
      visible: false,
      items:[
        { title : 'Kompetisi', name: 'form'},
      ]
    },
    { group: 'partai',
      visible: false,
      items:[
        { title : 'Partai', name: 'form' },
      ]
    },    
    { group: 'calon',
      visible: false,
      items:[
        { title : 'Calon', name: 'form' },
        { title : 'Calon', name: 'view' },
      ]
    },
    { group: 'user',
      visible: false,
      items:[
        { title : 'Calon', name: 'form' },        
      ]
    },
    { group: 'saksi',
      visible: false,
      items:[
        { title : 'Saksi/Child', name: 'form' },        
      ]
    },
    {
        title   : 'Auth',
        group   : 'rbac',
        visible: false,                   
        items: [            
            {title: 'Permissions', name: 'permissions/form'},
            {title: 'Permissions', name: 'permissions/view'},
            {title: 'Roles', name: 'roles/form'},
            {title: 'Roles', name: 'roles/view'},
            {title: 'Assignment', name: 'assignment/view'}            
        ]
    },
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
